import ReactLoading from "react-loading";
import "./Loader.scss";
export default function Loader() {
  return (
    <ReactLoading
      type="spin"
      color={"orange"}
      height={70}
      width={70}
      className="loader-style"
    />
  );
}
